















module.exports =
	components:
		'navigation': require './navigation'
		'home': require '../pages/home/index'
		'site-footer': require './footer'



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layout/app.vue